/**
   * Attend une date et renvoie la correspondance en Date Fr
   * @param {dateFormat} date 
   * @returns [string, string, string, string, string, string] [Jeudi, 01, Janvier, 1970, 14, 00]
   */
export const convertDate = (date) => {

  const d = new Date(date);
  const day = d.getDay();
  const month = d.getMonth();
  let dayMonth = d.getDate();
  const year = d.getFullYear();
  const hours = d.getHours();
  let minutes = d.getMinutes();

  if (minutes === 0) minutes = "0" + 0


  const listDay = [
    "Lundi",
    "Mardi",
    "Mercredi",
    "Jeudi",
    "Vendredi",
    "Samedi",
    "Dimanche",
  ];

  const listMonth = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septempbre",
    "Octobre",
    "Novembre",
    "Décembre"
  ]

  if (dayMonth >= 1 && dayMonth <= 9) {
    dayMonth = "0" + dayMonth
  }


  return [listDay[day - 1], dayMonth, listMonth[month], "" + year, "" + hours, minutes]
}
